export const RULES_PERMISSION = 'rules'
export const ADS_MANAGER_PERMISSION = 'ads_manager'
export const INTERESTS_PERMISSION = 'interests'
export const POST_BOOSTING_PERMISSION = 'post_boosting'
